// 3.9 · „Adaugă în coș" înainte de prima adăugare, „− 1 +" după.
//
// Nu conține logică de coș. Modul bulk din Dawn o are deja — actualizare fără
// părăsirea listei, plafon de stoc, re-randarea sertarului — și e greșit doar la
// ordine: arată contorul din start. Aici doar ținem butonul deasupra contorului
// cât timp cantitatea e 0, iar la clic scriem cantitatea și lăsăm Dawn să adauge.
(function () {
  'use strict';

  function quantityOf(host) {
    var input = host.querySelector('quantity-input input');
    if (!input) return 0;
    return parseInt(input.value, 10) || 0;
  }

  function sync(host) {
    // Fără contor randat (produs epuizat) nu avem ce comuta.
    if (!host.querySelector('quantity-input')) return;
    if (quantityOf(host) === 0) host.classList.add('caf-empty');
    else host.classList.remove('caf-empty');
  }

  function syncAll() {
    var hosts = document.querySelectorAll('quick-add-bulk');
    Array.prototype.forEach.call(hosts, sync);
  }

  document.addEventListener('click', function (e) {
    var el = e.target;
    var btn = null;
    while (el && el !== document) {
      if (el.hasAttribute && el.hasAttribute('data-caf-add')) { btn = el; break; }
      el = el.parentNode;
    }
    if (!btn) return;

    var host = btn.parentNode;
    while (host && host !== document && String(host.tagName).toLowerCase() !== 'quick-add-bulk') {
      host = host.parentNode;
    }
    var input = host && host.querySelector ? host.querySelector('quantity-input input') : null;
    if (!input) return;

    e.preventDefault();
    // Contorul apare imediat, ca apăsarea să aibă un răspuns vizibil înainte de
    // răspunsul serverului.
    host.classList.remove('caf-empty');
    input.value = parseInt(input.getAttribute('data-min'), 10) || 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // Starea „coș gol" e o clasă pe <cart-drawer>, iar re-randarea de după
    // adăugare schimbă doar interiorul lui #CartDrawer — deci clasa ar rămâne
    // pusă peste conținut proaspăt și ar ascunde antetul și produsul. Coșul
    // sigur nu mai e gol după clicul ăsta.
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.remove('is-empty');
  });

  // Sertarul: închide și lasă clientul unde era.
  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el !== document) {
      if (el.hasAttribute && el.hasAttribute('data-caf-continue')) {
        e.preventDefault();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
        else if (drawer) drawer.classList.remove('animate', 'active');
        return;
      }
      el = el.parentNode;
    }
  });

  // Dawn re-randează secțiunile după fiecare schimbare de coș, deci starea
  // butoanelor se reface din HTML nou, nu din memoria noastră.
  var pending = null;
  function schedule() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(syncAll, 80);
  }

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
